<template lang="pug">
.order_confirm_ctn
  .order-confirm(ref="orderConfirm" :class="{'limit': isShowLimit}")
    .cf-top
      .part-title 确认订单
        .fr(@click="$emit('confirmBack')") <返回修改
      .part-round
        img.part_round_img(:src="image1")
        span 客户信息
      .user-info
        span.each 联系人：
          span {{topInfo.contacter}}
        span.each 联系人电话：
          span {{topInfo.contactPhone}}
        span.each.noMr 认证主体：
          span {{topInfo.customerName}}

    .cf-info
      .part-round
        img.part_round_img(:src="image2")
        span 订单信息
      .put-out
        .put-time(style='line-height:34px;')
          template(v-if="chargeMode == 'cpmL'")
            span 起始日期：
              span.date.no-br {{searchInfo('time0') | date1}}(预计投放{{dayNum}}天)
          template(v-else)
            span 投放日期：
              span.date.no-br {{searchInfo('time0') | date1}} ~ {{searchInfo('time1') | date1}}(共{{dayNum}}天)
          span.itemTag 订单组别：
            div.selectText(@click="textClickSelect" style="pointer-events: none;")
              span(v-if="currentGroup.startDate") {{ currentGroup.startDate+'~'+ currentGroup.endDate }}
              el-tag(v-if='currentGroup.tag' size='mini' style='color:#409EFF;background-color:#ecf5ff;border-color:#d9ecff') {{ currentGroup.tag }}
            el-select(v-model="orderGroupCode"  placeholder="请选择订单组别" size='small' style='width:360px' value-key='code' ref="groupSelectRef" @visible-change='handleVisibleChange')
                el-option(v-for="item in orderGroupList"  :key="item.code" :label="''" :value="item")
                  div(style='display:flex;align-items:center;justify-content:space-between')
                    span {{ item.startDate+'~'+ item.endDate }}
                    el-tag(v-if='item.tag' size='mini' ) {{ item.tag }}
            i.el-icon-edit-outline(@click="groupListVisiableChange")
        .put-time(v-if="!isWifi")
          span.row_els 投放时段：
            el-popover(placement="top-end" width="350" trigger="hover")
              span.no-br(v-html="timeSlots" slot="reference")
              div(v-html="timeSlots")
        .put-time
          template(v-if="!isExport")
            StrPop(v-if="!isNotfromMap" w="100")
              span(slot="reference") 投放城市：
                span.value_els {{ searchInfo('city') }}
              div(style="font-weight:bold;color: #282729;" v-html="(searchInfo('city') || '').split(',').reduce((res, el) => res + '<div>' + el + '</div>'), ''")
            StrPop(v-else-if="!isReportReput" trigger="click")
              span(slot="reference") 投放城市：
                span.value_els {{ conditionSearchCitys }}
              div.city_pop_box
                div(v-for="city in cdSearchCitysPop")
                  .title(style="margin-bottom: 5px;font-weight: bold;color: #282729;") {{ city.districtValue }}
                  div(style="margin-bottom: 10px;color: #666;") {{ city.children && city.children.map(el => el.districtValue).join('、') }}

          span(v-if="reputData.addressNames") 投放城市：
            span {{ reputData.addressNames }}

          span(v-if="!isWifi") 单次曝光：
            span {{ searchInfo('contentTime') }}
          template(v-if="!isH5RealTime && !isWifi && !isSmallSn")
            span 收费方式：
              span(:class="{ 'no-br': !isCpm && !isNotfromMap }") {{ labelChooseSortStr('CHARGE_TYPE') || 'CPD' }}
            //- 预算金额/预估流量
            span(v-if="isCpm") {{ targetLabelStr }}：
              span(:class="{ 'no-br': !isNotfromMap }") {{ targetValueStr ? targetValueStr + cpmAppendStr : '不限'}}

          span(v-if="isNotfromMap") 合同编码：
            span.no-br(v-if="isPkg") {{ $store.state.order.pkgContracts.join(',') || '暂无' }}
            span.no-br(v-else) {{ filtro.contractNo || '未录入' }}
          span 展现位置：
            span.no-br {{ '主屏+副屏' }}

        .put-time(v-if="filtro.unitPrice")
          span 合同单价：
            span {{ filtro.unitPrice }} 元/千人次
          template(v-if="cprPlus")
            span 流量总限：
              span(v-if="filtro.targetFlowOrbudgetAmount") {{ filtro.targetFlowOrbudgetAmount }} 千人次
              span(v-else) 不限
            span 流量日限：
              span(v-if="filtro.dailyFlowLimit") {{ filtro.dailyFlowLimit }} 千人次
              span(v-else) 不限
            span 点位日限流量：
              span(v-if="filtro.pointLimitFlow") {{ filtro.pointLimitFlow }} 人次
              span(v-else) 不限
            span 点位日限频次：
              span.no-br(v-if="filtro.pointLimitPlayCount") {{ filtro.pointLimitPlayCount }} 次
              span.no-br(v-else) 不限

        .put-time.cpr_label(v-if="cprPlus")
          FlowCustomize(@customize="handleCustomize")
          .cprplus_mode 投放模式：
            div.no-br {{ cprPlusModeName }}

        template(v-if="!isExport")
          .put-time(v-if="isNotfromMap && chooseIndusStr")
            span 我的行业：
              span.no-br {{ chooseIndusStr }}
          template(v-else)
            .put-time(v-if="!cprPlus")
              span 社区收入：
                span {{ reputData.incomeLevel || labelChooseSortStr('INCOME') || '不限' }}

              StrPop.no-br(v-if="reputData.community || labelChooseSortStr('PLACE_TYPE')")
                span(slot="reference") 社区类型：
                  span.value_els {{ reputData.community || labelChooseSortStr('PLACE_TYPE') }}
                div {{ reputData.community || labelChooseSortStr('PLACE_TYPE') }}
              span(v-else) 社区类型：
                span 不限

              StrPop.no-br(v-if="labelChooseSortStr('POINT_FEATURE')")
                span(slot="reference") 点位特征：
                  span.value_els {{ labelChooseSortStr('POINT_FEATURE') }}
                div {{ labelChooseSortStr('POINT_FEATURE') }}
              span(v-else) 点位特征：
                span 不限

            .put-time(v-if="showUserProfile")
              span.usepf_span.confirm 用户画像：
                span.no-br(style="position: relative;top: 0;")
                  div(v-if="reputData.person")
                    StrPop(v-for="(item, i) in reputData.person" :key="item")
                      span(slot="reference") {{ userPfNames[i] }}
                        span(v-if="i < reputData.person.length - 1" style="margin: 0 5px;") 或
                      div {{ userPfNames[i] + ': ' + item }}
                  UserProfileChange(v-else v-model="upfData" :onlyshow="true")

        template(v-if="choosePkg")
          .put-time
            span 套餐名称：
              span {{ choosePkg.packageName }}
            span 目标流量：
              span {{ (choosePkg.reachPersons || 0) * choosePkg.packageInfoCodes.slice(0, choosePkg.num).length }}人次
            span 套餐数量：
              span.no-br {{ choosePkg.num }}

          .put-time.pkg_list_ctn
            span(slot="reference" style="width: calc(100% - 60px);display: inline-block;") 套餐券码：
              span.pkg_list.no-br(:class="{ 'els': !isPkgShowMore }") {{ (choosePkg.packageInfoCodes || []).slice(0, choosePkg.num).join('、') }}
            .fr.btn(@click="isPkgShowMore = !isPkgShowMore")
              span(v-if="isPkgShowMore") 收起
              span(v-else) 展开

        .put-time
          span
            span.date.no-br 共选{{chooseNum(2)}}个点位
              template(v-if="!isWifi") （梯内屏{{chooseNum(2, 0)}}个，梯外屏{{chooseNum(2, 1)}}个）
              | ；覆盖{{chooseNum(1)}}个小区
            span.date.no-br(v-if="isCpm" style="position: relative;left: -40px;") ；预计流量{{ cpmAccountNum }}（千人次）
          .less.fr(v-if="isShowCmShort && !isSmallSn") 缺货:
            span.btn(@click="$refs.shortFixCenter.show()") 查看明细

    .put_info
      .part-round
        img.part_round_img(:src="image3")
        span 小区信息
        .fr(style="position: relative;top: -4px;")
          el-input.searchArea(placeholder="查找小区" clearable v-model="nbhdSearchStr" @keyup.enter="searchNbhd" @change="searchChange")
          i.el-icon-search.fr(
            @click="searchNbhd"
            style="position: relative;top: 7px; right: 100px;z-index: 1;cursor: pointer;"
          )
          el-button(size="mini" @click="exportSearchResult" style="margin-left: 10px;height: 30px;position: relative;top: -1px;")
            i.el-icon-download
            | 导出

      .community-list(ref="listCtn")
        .gg-tabs(style="border-bottom: 1px solid #e9e9e9;margin-bottom: 10px;" v-if="showTnTwTabs")
          .gg-tab(
            v-for="(item, i) in tabs" :key="i" @click="toggleTypeTab(i)"
            :class="{'cur': curTab == i, 'disabled': showTabNoChoose(i)}"
          ) {{item}}
            span {{showTabNoChoose(i) ? '(未选)' : ''}}
        .none(v-if="!showCommunityList || showCommunityList.length == 0") 暂无数据
        .community-item(
          v-for="(item, i) in showCommunityList" :class="{'isOpen': item && item.isOpen}"
          @click="clickNbhd(item)"
        )
          template(v-if="item")
            .top {{item.name}}
              .fr 合计金额：
                span.price {{(item.slotAmount ? item.slotAmount - 0 : 0).toFixed(2)}}元
                | 总点位数：
                span.num(:class="isWifi ? 'no-br': ''") {{item.deviceCount}}个
                template(v-if="!isWifi")
                  | 已投：
                  span.num.no-br(v-if="chargeMode == 'cpmL'") {{item.validDays || 0}}天
                  span.num.no-br(v-else) {{item.days ? item.days.length : 0}}天

                i.el-icon-arrow-down
            .community-main(v-if="item.isOpen" @click.stop="" style="text-align: center;margin: 0 -5px;")
              .detail_screen(:style="{ width: listCtnWidth + 'px' }")
                template(v-for="(it, j) in item.nbhdDailyRes")
                  .detail_de(v-if="isShowBuild") {{it}}
                  DateDeviceItem(v-else :data="it" :idx="i" @show="nbhdDateClick(item, j, it)")
  .upFooter
    .fl
      CouponPoper(:payPrice="noCouponPrice" @cpChange="toggleCp" ref="couponPoper")
    .fr(v-if="isShowLimit") 保留限制小区
      span(@click="() => { $refs.limitFix.show() }") 小区列表
      el-checkbox(v-model="ggjcSwitch" :indeterminate="indeterminate")

  .footer
    .fx_l
      el-popover(placement="top" width="200" trigger="click")
        .countDetail
          .countLine
            span 广告总价：
            span(style="font-weight:600;color:#282729;") +￥{{fee(allPrice)}}
              span(style="color:#282729;") .{{fee(allPrice, 1)}}
          .countLine
            span 满减折扣：
            span -￥{{discountMoney | toFix}}
          .countLine
            span 活动金额：
            span -￥{{activeShortFee.toFixed(2)}}
          .countLine
            span 优惠券：
            span -￥{{(noCouponPrice - payPrice).toFixed(2)}}
          .countLine(v-if="payWay == 1")
            span 会员权益：
            span 减免{{chooseNum(2)}}点位

        .sunCount(slot="reference")
          span.s_title
            | 合计金额：
          .numDe
            .numUp(:style="{marginTop: discountMoney > 0 ? '0' : '4px'}" v-if="payWay == 1") ￥0.00
            .numUp(:style="{marginTop: discountMoney > 0 ? '0' : '4px'}" v-else) ￥{{fee(payPrice)}}
              span .{{fee(payPrice, 1)}}
              i.iconfont.icon-bangzhu
            span(v-if="discountMoney > 0")
              .numDown ￥{{fee(allPrice)}}
                span .{{fee(allPrice, 1)}}

      .ft_choose
        span(style="font-weight: 550;") 支付方式
        el-radio-group(v-model="payWay")
          el-radio(v-for="(item, i) in payWays" :label="item.payWayCode" :key="i" v-if="showPayWay(item)") {{item.payWayName}}
            span(v-if="item.payWayCode == 1") ({{item.amount < 0 ? 0 : item.amount}}个)

      //- .ft_choose
      //-   span(style="font-weight: 550;") 上链服务
      //-   el-radio-group(v-model="chainFlag")
      //-     el-radio(:label="1") 启用
      //-     el-radio(:label="2") 不启用

    .ft_choose
      div(style="margin-right:10px;")
        span(style="font-weight: 550;") 数据存储
          el-tooltip(effect="dark" placement="top-start")
            i.el-icon-question(style="margin-left: 5px;")
            div(slot="content")
              div 播放数据存储的有效期,包
              div 括数据报告&流量抓图
        el-input-number(
          v-model="storeDays"
          class="num_input"
          style="width:80px;margin-left: 5px;margin-right: 5px;"
          size="mini"
          placeholder="30"
          controls-position="right"
          step-strictly
          :min="1"
          :max="1095"
          :precision="0")
        span 天
      .submit-btn(@click="setOrder") 提交订单

  fix-center(ref="shortFixCenter" w="790" h="600")
    template(slot="title") 缺货详情
    template(slot="main")
      ShortNbhdList(:data="communityListShort")
    template(slot="btm")
      el-button(size="mini" class="exp_btn" @click="shortageExport") 导出
      el-button(size="mini" @click="$refs.shortFixCenter.hide()" style="width:100px;margin-top:15px") 关闭

  fix-center.limit-fix(ref="limit" w="400" h="300" :hideClose="true")
    template(slot="title") 温馨提示
    template(slot="main")
      div(style="padding: 40px 35px;text-align: center;line-height: 1.5") 你选中的部分小区存在广告投放限制，请问是否需要保留这些被限制的小区？
    template(slot="btm")
      .fix-btn.red(
        size="mini" style="width: 120px;"
        @click="() => { chooseLimitList = cmLimitList; ggjcSwitch = true; $refs.limit.hide() }"
      ) 是的，保留
      .fix-btn(size="mini" style="width: 120px;" @click="noKeep") 不了，谢谢

  fix-center.limit-fix(ref="limitFix" w="790" h="660")
    template(slot="title") 限制小区详情
    template(slot="main")
      CmLimitList(ref="limitFixCp" :data="cmLimitList" :chooseList="chooseLimitList")
    template(slot="btm")
      .fix-btn.red(size="mini" @click="changeLimitChoose") 确定
      .fix-btn(size="mini" @click="cancelLimitChoose") 取消

  fix-center.limit-fix(ref="vipFree" w="400" h="300")
    template(slot="title") 温馨提示
    template(slot="main")
      .vip_tip 会员免费投放额度剩余{{vipPointRemain}}个，当前投放数量超出此范围，请返回修改后再投放～
    template(slot="btm")
      .fix-btn(size="mini" @click="() => { $refs.vipFree.hide() }") 知道了
  groupListVisiable(ref='groupListVisiableref' @confirmGroup='confirmGroup' :contractCodes='filtro.contractNo')
</template>

<script>
import image1 from '@/assets/Group 3@2x.png'
import image2 from '@/assets/Group 3list@2x.png'
import image3 from '@/assets/Group 3info@2x.png'
import DateDeviceItem from './components/DateDeviceItemConfirm.vue'
import groupListVisiable from './groupListVisiable.vue'
import ShortNbhdList from './components/ShortNbhdList.vue'
import CmLimitList from './components/LimitNbhds.vue'
import CouponPoper from './components/CouponPoper.vue'
import StrPop from '@/components/StrPop.vue'
import disCount from '@/utils/mixins/discount'
import UserProfileChange from '@/components/userprofile/UserProfileChange'
import FlowCustomize from '@/views/PutCprPlus/components/FlowCustomize.vue'
import { customerById } from '@/utils/customerApi'
import {jsUuid} from '@/utils/functions.js'

let deviceNbhdMap = {} // 选取的小区中的点位map

export default {
  name: 'order-confirm',
  filters: {
    date1(v) {
      if (!v) return ''
      let year = v.getFullYear()
      let month = String(v.getMonth() + 1).length === 1?'0'+(v.getMonth() + 1):(v.getMonth() + 1)
      let day = String(v.getDate()).length === 1?'0'+(v.getDate()):(v.getDate())
      return  year+ '年' + month + '月' + day +'日'
    },
    shortDates(arr) {
      if (!arr || arr.length === 0) return ''
      else return arr.map((el) => el.targetDate).join('、')
    },
    toFix(v) {
      return (v - 0).toFixed(2)
    }
  },
  components: {
    groupListVisiable,
    DateDeviceItem,
    ShortNbhdList,
    CouponPoper,
    CmLimitList,
    StrPop,
    UserProfileChange,
    FlowCustomize
  },
  props: ['options'],
  mixins: [disCount],
  data() {
    return {
      orderGroupCode:{}, // 订单组别
      hasGroupListFlag:true,// 是否关联订单组别
      image1,
      image2,
      image3,
      topInfo: {},
      ggjcSwitch: true,
      nbhdSearchStr: '',
      communityListShort: [],
      timeSlots: '',
      isShowCps: false,
      cpTab: 0,
      curChooseCpIdx: -1,
      isSubmiting: false,
      activeShortFee: 0,
      activeShortName: '',
      tdTime: new Date().setHours(0, 0, 0, 0),

      communityList: [],
      allPrice: 0,
      payPrice: 0,
      noCouponPrice: 0,
      chooseCoupon: 0,
      chooseCouponId: '',
      listCtnWidth: 0,
      datasDeviceData: [],
      cmLimitList: [],
      allCmLimitList: [],
      noLimitList: [],
      chooseLimitList: [],
      hasShowLimit: false,
      isShowLimit: false,
      conditionSearchCitys: '',
      cdSearchCitysPop: [],

      tabs: ['梯内屏', '梯外屏'],
      curTab: -1,
      allCommunityList: [], // 当前可以展示的所有小区 包括梯内梯外，不包括限制小区中未勾选的
      showCommunityList: [],

      payWay: 0, // 支付方式

      _allShowList: [],
      _showLen: 30,
      _listMinH: 60,
      _showIdxS: 0,

      chainFlag: 2, // 上链状态  启用 1   不启用 2
      storeDays: 1,
      userPfNames: ['画像A', '画像B', '画像C', '画像D', '画像E'],

      cpmAccountNum: 0,
      isPkgShowMore: false,
      reputData: {},

      targetLabels: [],
      orderGroupList: [],
      isDropdownOpen: false, // 自己维护状态
      currentGroup: {},
    }
  },
  inject: {
    pageVm: { default: null },
    repeatOrder: { default: null }
  },
  computed: {
    filtro() {
      return this.options.conditionData || {}
    },
    cprPlus() {
      const { orderType } = this.filtro || {}
      return !!(orderType !== undefined && orderType === 6005)
    },
    cprPlusModeName() {
      const m = {
        1: '标准',
        2: '高级'
      }
      return m[this.filtro.dmpInterruptType]
    },
    choosePkg() {
      return this.options && this.filtro && this.filtro.choosePkg
    },
    // 用户画像选择的codes
    userPfCodes() {
      return this.$store.state.label.confirm.persons
    },
    upfData() {
      return this.$store.state.label.confirm.personsData.filter((el) => el.list.length)
    },
    showUserProfile() {
      return !this.isExport && !this.cprPlus
    },
    labelCodeMap() {
      return this.$store.state.label.codeMap
    },
    userLabelStr() {
      const arr = this.userPfCodes
      if (!arr || arr.length === 0) return ''
      // 只有一个画像,各标签名称用"+"连接
      if (arr.length === 1) {
        return arr[0].map(w => w.name).join('+')
      }
      return arr
        .map((list) => {
          let str = list.map((el) => code2name[el].name).join('+')
          return list.length == 1 ? str : `(${str})` // 一个属性时不展示括号
        })
        .join(' / ')
    },
    labelChooseSortStr() {
      let map = this.$store.state.label.sortMap
      let chooses = this.$store.state.label.confirm.labels
      return (sort) => {
        return (
          (map[sort] &&
            map[sort]
              .filter((el) => chooses.some((ele) => el.code == ele)) // 过滤出当前type中选择的labels里有的数据
              .map((el) => el.name) // 拼接name展示
              .join('、')) ||
          ''
        )
      }
    },
    labelContextMap() {
      return this.$store.state.bmap.labelContextMap
    },
    labelContextMapName() {
      // labelList 对应的code+value 对应的 对象
      return (key) => {
        if (this.labelContextMap[key]) return this.labelContextMap[key].context
        return ''
      }
    },
    indusCodeStr() {
      return (code) => {
        let cd = this.$store.state.order.indusCodeMap[code]
        return cd ? cd.pData.name + '(' + cd.name + ')' : ''
      }
    },
    chooseIndusStr() {
      let cd = this.filtro
      let data = cd && cd.industryCodes && cd.industryCodes[0] ? this.indusCodeStr(cd.industryCodes[0]) : ''
      return data ? data : cd.labelDataChangeType === 'indus' ? '不限' : ''
    },
    showTnTwTabs() {
      return !this.isSmallSn && !this.isWifi && this.isCpd
    },
    chargeMode() {
      // 收费方式
      return this.$store.state.order.choosePayWay // 'cpd', 'cpmT'(CPR按天), 'cpmL'(CPR按流量), 'pkg'(套餐兑换)
    },
    isCpd() {
      return !this.chargeMode || this.chargeMode == 'cpd'
    },
    isCpm() {
      return this.chargeMode.indexOf('cpm') > -1
    },
    isPkg() {
      return this.chargeMode === 'pkg'
    },
    targetValueStr() {
      let conditionData = this.filtro
      let targetFlowData = conditionData.targetFlowData || conditionData.selectSlotRequest.targetFlowData
      if (!targetFlowData) return ''
      return targetFlowData.targetFlowOrbudgetAmount || ''
    },
    targetLabelStr() {
      return this.labelChooseSortStr('TARGET') || '不限'
    },
    cpmAppendStr() {
      if (!this.isCpm) return ''
      let str = this.targetLabelStr
      if (!str || str == '不限') return ''
      return '千人次'
    },
    isH5RealTime() {
      return this.$store.state.order.h5RealTime == 1
    },
    vipPointRemain() {
      // 会员限免点位余量
      return this.$store.getters['customer/vipFreeRemain']
    },
    payWays() {
      let payWays = this.$store.state.order.payWayList || []
      if (this.isCpd) return payWays
      else return payWays.filter((el) => el.payWayCode != 1) // 非cpd模式不能使用会员权益支付
    },
    isSmallSn() {
      // 是否是小屏投放或小屏导入点位
      let name = this.$store.state.order.conditionSearchTypeName
      return name.toLowerCase().indexOf('smallsn') > -1
    },
    showPayWay() {
      // 小屏投放不展示会员权益支付方式
      return (item) => !(this.isSmallSn && item.payWayCode == 1)
    },
    showTabNoChoose() {
      return (i) => {
        return this.allCommunityList.filter((el) => el.type == i).length <= 0
      }
    },
    isShowCmShort() {
      return this.communityListShort && this.communityListShort.filter((el) => el && el.length).length > 0
    },
    isNotfromMap() {
      console.log(this.options,'this.options')
      let options = this.options
      return !Array.isArray(options) && (options.type == 'excelImport' || options.type == 'condition')
    },
    isReportReput() {
      return this.$store.state.order.searchTabType === 'orderReput'
    },
    isExport() {
      return this.isNotfromMap && this.options.isExport
    },
    isWifi() {
      // 表示是否是实时或者网络广告 options带过来的 isWifi 属性  实时广告和网络广告 到订单详情这里都带过来是true
      return this.isNotfromMap && this.options.isWifi
    },
    isShowBuild() {
      return this.isWifi || this.chargeMode == 'cpmL'
    },
    indeterminate() {
      return this.cmLimitList.length > 0 && this.chooseLimitList.length > 0 && this.chooseLimitList.length < this.cmLimitList.length
    },
    chooseNum() {
      return (type, keys) => {
        if (type == 1) {
          // 小区数
          let noLimitListNoRepeat = this.noLimitList.reduce(
            // 过滤重复的小区
            (res, el) => {
              if (res.every((each) => each.guid != el.guid)) res.push(el)
              return res
            },
            []
          )
          let nbhds = noLimitListNoRepeat.concat(this.chooseLimitList)
          if (keys && keys.length) {
            // 小区中某些key的值的组合
            return nbhds.reduce((res, cur) => {
              let optionsCurNbhdData = this.options.data.filter((el) => el.guid == cur.guid)[0]
              return res + keys.reduce((itemRes, item) => (optionsCurNbhdData[item] || 0) - 0 + itemRes, 0)
            }, 0)
          }
          return nbhds.length
        } else if (type == 2) {
          // 点位数
          if (keys === undefined) {
            return this.noLimitList.concat(this.getTnTwChooseList()).reduce((a, b) => b.deviceCount + a, 0)
          } else {
            let nbhds = this.noLimitList.concat(this.getTnTwChooseList()).filter((el) => el.type == keys)
            return nbhds.reduce((a, b) => b.deviceCount + a, 0)
          }
        }
      }
    },
    customer() {
      return this.$store.state.customer.customerInfo
    },
    dayNum() {
      let data = this.$store.state.bmap.mapSearchOptions.time
      if (!data[1]) {
        if (this.options.needDays) return this.options.needDays
        return 0
      }
      if (data && data.length > 0) return (new Date(data[1]) - new Date(data[0])) / (24 * 3600000) + 1
      return 0
    },
    coupons() {
      return this.$store.state.coupon.allCoupon || []
    },
    okCps() {
      return this.storeGet('coupon/okCoupons') || []
    },
    canOkcps() {
      if (!this.okCps || this.okCps.length == 0) return []
      let td = new Date().setHours(0, 0, 0, 0)
      let data = this.okCps.filter((el) => el.limit - 0 <= this.payPrice).filter((el) => new Date(el.startTime).getTime() <= td && new Date(el.endTime).getTime() >= td)
      return data
    },
    cannotOkcps() {
      let td = new Date().setHours(0, 0, 0, 0)
      return this.okCps.filter((el) => {
        return el.limit - 0 > this.payPrice || new Date(el.startTime).getTime() > td || new Date(el.endTime).getTime() < td
      })
    },
    numCoupons() {
      return (idx) => (idx == 0 ? this.canOkcps.length : this.cannotOkcps.length)
    },
    shortAllNum() {
      return this.communityListShort.reduce((cur, next) => cur + next.shortageAmount, 0)
    },
    fee() {
      return (money, type) => {
        if (!money) return type ? '00' : 0
        let isMinus = money < 0
        if (isMinus) money = 0 - money
        if (!type) {
          let arr = (Math.floor(money) + '').split('').reverse()
          let a = []
          arr.forEach((el, i) => {
            a.push(el)
            if ((i + 1) % 3 == 0) a.push(',')
          })
          let str = a.reverse().join('')
          let data = str.charAt(0) == ',' ? str.slice(1) : str
          return isMinus ? '-' + data : data
        } else {
          money = (money - 0).toFixed(2)
          let sp = (money + '').split('.')
          return sp.length > 1 ? (sp[1].length == 1 ? sp[1] + '0' : sp[1].substr(0, 2)) : '00'
        }
      }
    },
    searchInfo() {
      let data = this.$store.state.bmap.mapSearchOptions
      return (type) => {
        if (type === 'city') {
          let seniorCityGuid = this.$store.state.bmap.mapSearchOptionsSenior.city
          if (!seniorCityGuid) return '全国'
          else return this.$store.state.bmap.mapCityList.filter((el) => el.guid == seniorCityGuid)[0].districtValue
        }
        if (type.indexOf('time') > -1) {
          let time = data.time[type.replace(/time/, '')]
          if (type == 'time1' && !time) {
            // 结束时间可能不存在 由开始时间加上  options.needDays 计算得出
            let needDays = this.options.needDays ? this.options.needDays - 1 : 0
            return new Date(new Date(data.time[0]).getTime() + needDays * 24 * 60 * 60 * 1000)
          }
          return data.time && data.time.length > 0 ? new Date(data.time[type.replace(/time/, '') - 0]) : ''
        }
        if (type == 'contentTime') return data.contentTime ? data.contentTime + '秒' : '不限'
        return '不限'
      }
    },
    isFormSearch() {
      return this.$route.path == '/putOrder'
    },
    displayRegionName() {
      console.log('11111')
      const regNum = this.isNotfromMap ? this.filtro.displayRegion : this.$store.state.bmap.mapSearchOptions.displayRegion
      if (!regNum) {
        return '不限'
      }
      switch (regNum) {
        case 1:
          return '主屏'
        case 2:
          return '副屏'
        case 3:
          return '主屏+副屏'
      }
      return ''
    }
  },
  watch: {
    payWay(v) {
      if (v == 1) {
        if (this.vipPointRemain < this.chooseNum(2)) {
          this.$refs.vipFree.show()
          this.$nextTick(() => {
            this.payWay = 0
          })
        }
      }
    },
    async orderGroupCode(v, o) {
      const topGroup = v
      // const timeStr = this.chargeMode == 'cpmL'?this.formatterTiemStr(this.searchInfo('time0')):`${this.formatterTiemStr(this.searchInfo('time0'))} ~ ${this.formatterTiemStr(this.searchInfo('time1') )}`
      this.currentGroup =  {
        ...topGroup
      }
    },
    ggjcSwitch(v) {
      if (v) this.chooseLimitList = this.cmLimitList
      else this.chooseLimitList = []

      this.communityList = this.noLimitList.concat(this.getTnTwChooseList())
      this.handleAllCmListLimit(this.chooseLimitList)
    },
    chooseLimitList: {
      deep: true,
      handler() {
        this.getPayPrice()
      }
    },
    curTab() {
      // 重置搜索的输入字段，设置 notShow 为 false ， 展示当前对应tab组数据
      this.nbhdSearchStr = ''
      this.searchNbhd()
    }
  },
  async created() {
    //* 数据报告&流量抓图数据存储时间逻辑(20220812)
    if (this.chargeMode === 'cpd') {
      //* CPD: 统一存1天
      this.storeDays = 7
    } else {
      //* CPR(包含套餐): 投放时间为1-2周的,默认30天,投放时间2周以上的,默认60天
      this.storeDays = this.dayNum <= 14 ? 30 : 60
    }

    this.putTabType = this.pageVm && this.pageVm.curTab
    // 获取小区列表信息
    await this.getCommunitys()
    // 缺货列表
    if (!this.isSmallSn && !this.isWifi) await this.getShortAll()
    // 会员权益
    this.$store.dispatch('order/getPayWay')
    // 智能快速投放条件筛选过来的 处理所属城市展示
    this.handleConditionCity()
    // 每次进入都更新下优惠券
    this.$store.dispatch('coupon/getAllCoupon')
    if (!this.isWifi) {
      // 时间段显示处理
      this.timeSlots = (await this.getTimeSlots()).join(' ')
    }
    document.body.className = 'body_order_confirm'

    // if (this.isCpm) this.handlePredictFlowChange()
    this.handlePredictFlowChange()

    if (this.putTabType == 'orderReput') this.handleReputOrder()
  },
  async mounted() {
    this.$nextTick(() => {
      this.$refs.orderConfirm.addEventListener('scroll', this.bdClick)
    })
    this.getOrderTagList()
    this.getTopInfo() // 确认订单顶部客户信息
  },
  beforeDestroy() {
    document.body.className = ''
    window.removeEventListener('resize', this.handleListCtnWidth)
    this.$refs.orderConfirm.removeEventListener('scroll', this.bdClick)
  },
  methods: {
    textClickSelect(event) {
        if (this.isDropdownOpen) {

          this.$refs.groupSelectRef.blur()
          this.isDropdownOpen = false
        } else {
          this.$refs.groupSelectRef.focus()
          this.isDropdownOpen = true
          // this.$refs.groupSelectRef.visible = true
          this.$set(this.$refs.groupSelectRef,'visible',true)
        }
    },
    // 监听下拉框状态变化
    handleVisibleChange(visible) {
      this.isDropdownOpen = visible
    },
    formatterTiemStr(v) {
      if (!v) return ''
      let year = v.getFullYear()
      let month = String(v.getMonth() + 1).length === 1?'0'+(v.getMonth() + 1):(v.getMonth() + 1)
      let day = String(v.getDate()).length === 1?'0'+(v.getDate()):(v.getDate())
      return  year+ '-' + month + '-' + day
    },
    confirmGroup() {
      this.getOrderTagList()
    },
    // 比较时间范围是否包含
    /**
     * @param {Date} currentDate 当前组别范围
     * @param {Date} targetDate 目标组别范围(动态)
     */
    compareTime(currentDate, targetDate) {
      const startTiemFlag = +new Date(currentDate.startDate) >= +new Date(targetDate.startDate)
      const endTiemFlag = +new Date(currentDate.endDate) <= +new Date(targetDate.endDate)
      return startTiemFlag && endTiemFlag
    },
    // 获取组别
    async getOrderTagList() {
      const result = await this.fetch('/orderlite/contract/api/v4/contract/order-groups/page', {
        pageNum: 1,
        pageSize: 99999,
        contractCodes:[this.filtro.contractNo]
      },'post')
      if (result.code === 0) {
        const timeStr = `${this.formatterTiemStr(this.searchInfo('time0'))} ~ ${this.formatterTiemStr(this.searchInfo('time1') )}`
        console.log(timeStr)
        let startDate = timeStr.split('~')[0].trim()
        let endDate = timeStr.split('~')[1].trim()
        if (result.data.list && result.data.list.length) {
          this.orderGroupList = result.data?.list
          // const obj = this.orderGroupList.find((el) => this.compareTime({startDate, endDate},el))
          // if (obj) {
          //   this.orderGroupCode = obj
          // } else {
          //   this.orderGroupCode = this.orderGroupList[0]
          // }
          this.orderGroupCode = this.orderGroupList[0]
          this.hasGroupListFlag = true
        } else {
          this.orderGroupList = [
            {
              startDate: startDate.trim(),
              endDate: endDate.trim(),
              contractCode: this.filtro.contractNo,
              tag:'',
              code:jsUuid()
            }
          ]
          this.orderGroupCode = this.orderGroupList[0]
          this.hasGroupListFlag = false
        }
      } else {
        this.orderGroupList = []
      }
    },
    // 编辑组别
    groupListVisiableChange() {
      this.$refs.groupListVisiableref.showVisiable()
     },

    handleReputOrder() {
      let { communityNames, incomeLevelNames, personNames } = (this.repeatOrder && this.repeatOrder.searchLabelInfo) || {}
      this.reputData = {
        ...this.repeatOrder,
        community: (communityNames || []).join(','),
        incomeLevel: (incomeLevelNames || []).join(','),
        person: (personNames || []).map((el) => el.join(','))
      }
    },
    async getTopInfo() {
      if (this.options.searchChargeWay === 'pkg') {
        this.topInfo = await this.getcustomInfoById(this.filtro.customerId)
      } else {
        this.topInfo = this.customer
      }
    },
    async getcustomInfoById(id) {
      const res = await customerById(id)
      if (res && res.code === 0 && res.data) return res.data
      return {}
    },
    noKeep() {
      this.communityList = this.noLimitList
      this.ggjcSwitch = false
      this.chooseLimitList = []
      this.$refs.limit.hide()
      // if (this.isCpm) this.handlePredictFlowChange()
      this.handlePredictFlowChange()
    },
    handlePredictFlowChange() {
      // 预计流量变化（cpr 模式下 限制小区勾选变化影响）
      // if (Object.keys(deviceNbhdMap).length === 0) this.initDeviceNbhdMap()
      let list = Array.isArray(this.options) ? this.options : this.options.data || []
      this.initDeviceNbhdMap(list) // 不能缓存 可能切换勾选了不同的小区
      let num = list
        .filter((el) => this.allCommunityList.map((el) => el.guid).indexOf(el.guid) > -1)
        .reduce((res, cur) => {
          return deviceNbhdMap[cur.guid].filter((ele) => ele.check).reduce((data, de) => (de.realAdvFr || 0) - 0 + data, 0) + res
        }, 0)
      this.cpmAccountNum = this.handleFlowNumShow(num) // 人次展示数据
    },
    handleFlowNumShow(num) { // 展示向下取整，不作四舍五入
      const qianfen = num / 1000
      const intNum = Math.floor(qianfen)
      const rest = (qianfen - intNum + '').slice(0, 4) - 0
      return (intNum + rest).toFixed(2)
    },
    initDeviceNbhdMap(list) {
      // 初始化 deviceNbhdMap 小区的设备map对象
      list.forEach((nbhd) => {
        let bList = nbhd.buildDeviceList || []
        let arr = []
        if (nbhd.twBuildDeviceList) bList = bList.concat(nbhd.twBuildDeviceList)
        bList.forEach((el) => {
          ;(el.unitDeviceList || []).forEach((ele) => {
            if (ele.deviceList) arr = arr.concat(ele.deviceList)
          })
        })
        // if (deviceNbhdMap[nbhd.guid]) arr = arr.concat(deviceNbhdMap[nbhd.guid]) // 梯内梯外可能存在相同的小区   都保留着 最终得到梯内梯外所有的数据
        deviceNbhdMap[nbhd.guid] = arr
      })
    },
    handleShowList(list) {
      let showL = this.$data._showLen
      this.$data._allShowList = list
      this.showCommunityList = []
      this.showCommunityList.length = list.length
      let len = Math.min(list.length, showL)
      for (let i = 0; i < len; i++) {
        this.showCommunityList[i] = list[i]
      }
      this.$nextTick(() => {
        this.handleListScroll()
      })
    },
    handleListScroll() {
      this.$data._showIdxS = 0 // 重新展示整个列表数据 _showIdxS 须重置为0
      let _ctnDom = this.$refs.orderConfirm
      _ctnDom.removeEventListener('scroll', this.handleShowListChange)
      _ctnDom.scrollTop = 0
      _ctnDom.addEventListener('scroll', this.handleShowListChange)
    },
    handleShowListChange() {
      let thisData = this.$data
      let showL = thisData._showLen
      let list = thisData._allShowList
      if (thisData._showIdxS == list.length) return // 滚动到最后
      let _listMinH = thisData._listMinH
      let _ctnDom = this.$refs.orderConfirm
      let scrollTop = _ctnDom.scrollTop,
        idx = Math.floor(scrollTop / _listMinH)
      let partNum = Math.floor((idx + showL / 2) / showL)
      if (partNum > list.length / showL) partNum = Math.floor(list.length / showL)

      let newPartStart = partNum * showL // 新的一组的起始索引
      if (newPartStart > 0 && newPartStart < list.length && !this.showCommunityList[newPartStart]) {
        let len = Math.min(list.length, newPartStart + showL)
        for (let i = 0; i < len; i++) {
          // 快速拉动滚动条到底部，中间可能很多不会渲染  这里拿到最后的渲染地方 从0开始 判断没渲染的全部渲染上
          if (!this.showCommunityList[i]) this.showCommunityList[i] = list[i]
        }
        thisData._showIdxS = len
      }
      this.$forceUpdate()
      // 确认订单这里不用勾选  已展示出来的内容就不回滚时清空了
    },
    getExportMap() {
      let nbhdGuids = [],
        nbhdGuid_deviceGuid_map = {}
      let list = this.isNotfromMap ? this.options.data : this.options

      // 所有list中去掉限制小区中未勾选的小区
      let noWantNbhdGuids = this.getNoChooseLimitNbhds().map((el) => el.guid)
      list = list.filter((el) => noWantNbhdGuids.indexOf(el.guid) < 0)

      list.forEach((el) => {
        nbhdGuids.push(el.guid)
        if (!el.allDevices || el.allDevices.length == 0) {
          el.allDevices = this.getAllDevice([el])
        }
        nbhdGuid_deviceGuid_map[el.guid] = el.allDevices.filter((el) => el.check).map((el) => el.deviceGuid)
      })
      return { nbhdGuids: nbhdGuids.join(','), nbhdGuid_deviceGuid_map }
    },
    async exportSearchResult() {
      let param = await this.getOrderOpts()
      let { addressCodes, contentTime, startDate, frequencyList, endDate } = param
      if (!endDate) {
        let date = new Date(new Date(startDate).getTime() + this.needDays * 24 * 60 * 60 * 1000)
        endDate = date.getFullYear() + '-' + this.fillZero(date.getMonth() + 1) + '-' + this.fillZero(date.getDate())
      }
      let loading = this.$loading()
      let res = await this.fetch(
        '/boss/deviceSlot/v2/exportSearchResult',
        {
          ...param,
          addressCodes: addressCodes.map((el) => {
            if (el.split('.').length == 1) return el + '.'
            return el
          }),
          contentTime,
          selectSlotRequest: {
            startDate,
            endDate,
            frequencyList
          },
          noCheckStock: this.isWifi || this.isSmallSn ? '1' : '', // 网络(wifi)/实时广告投放、小屏投放、小屏导入，不检查库存，其余要检查库存
          smallScreen: this.isSmallSn, // 小屏投放、小屏导入导出时需要的字段
          h5: this.isH5RealTime,
          wifi: this.$store.state.common.isWifiPut,
          ...this.getExportMap()
        },
        'blob-post'
      )
      loading.close()
      if (res) {
        this.$blobSaveFile(res, '小区导出.xls')
      }
    },
    async clickNbhd(item) {
      item.isOpen = !item.isOpen
      if (!item.isOpen) return
      if (!this.isShowBuild) return
      let deviceGuids = item.deviceGuids || item.nbhdDailyRes[0].deviceGuids
      // 直接展示楼幢需要重新请求
      if (item.buildReq && !item.nbhdDailyRes) item.buildReq = false
      if (!item.buildReq) {
        // 是否已经请求
        item.nbhdDailyRes = [] // 防止请求未完毕出现代码结构在页面中
        item.buildReq = true // 已经请求过标识
        let res = await this.getDeviceDtls(deviceGuids)
        if (res && res.code == this.successCode) {
          if (res.data) {
            this.$set(
              item,
              'nbhdDailyRes',
              (res.data || []).reduce((data, cur) => {
                let result = [],
                  build = cur.build
                cur.value.forEach((el) => {
                  let ut = el.unit
                  el.elevatorNos.forEach((ele) => result.push(`${build}${ut}${ele}`))
                })
                return data.concat(result)
              }, [])
            )
          }
        }
      }
    },
    getTnTwChooseList() {
      let chooseGuids = this.chooseLimitList.map((ele) => ele.guid)
      return this.allCmLimitList.filter((el) => chooseGuids.indexOf(el.guid) > -1)
    },
    handleAllCmListLimit() {
      // 处理限制小区变更之后的展示相关
      this.allCommunityList = this.noLimitList.concat(this.getTnTwChooseList())
      this.handleShowList(this.allCommunityList.filter((el) => el.type == this.curTab))

      this.handlePredictFlowChange()
      // if (this.isCpm) this.handlePredictFlowChange()
    },
    toggleTypeTab(i) {
      if (this.allCommunityList.filter((el) => el.type == i).length > 0) this.curTab = i
    },
    bdClick() {
      document.body.click()
    },
    handlePopover(e) {
      // 触发关闭已经存在的弹窗
      document.body.click()
      // 移除事件以免影响其他区域的弹窗展示点击隐藏问题
      document.body.removeEventListener('click', this.handlePopover, true)
    },
    handleConditionCity() {
      if (this.isNotfromMap && !this.isExport) {
        let storeState = this.$store.state
        let cdSearchAdds = storeState.bmap.conditionSearchCitys // 勾选的市以及区
        let originUserDistTree = storeState.common.originUserDistTree
        let citys = cdSearchAdds
          .filter((el) => el.levelNum === 3)
          .map((el) => {
            return { ...el, children: [] }
          })
        citys.forEach((el) => {
          // 构建所选择的市 区 成citys 树
          cdSearchAdds.forEach((item) => {
            if (el.code == item.parentCode) {
              el.children.push(item)
            }
          })
        })

        if (citys.length === 0) {
          // 全国
          citys = originUserDistTree
        }

        let guidMap = originUserDistTree.reduce((data, cur) => {
          data[cur.guid] = cur
          return data
        }, {})

        // 先注释 只展示城市
        this.conditionSearchCitys = citys
          .map((el) => {
            let cdsStr = ''
            if (el.children && el.children.length > 0 && guidMap[el.guid].children.length !== el.children.length) {
              cdsStr = '(' + el.children.map((el) => el.districtValue).join(',') + ')'
            }
            return el.districtValue + cdsStr
          })
          .join(';')
        this.cdSearchCitysPop = citys
      }
    },
    async getDeviceDtls(deviceGuids) {
      let load = this.$loading()
      let res = await this.fetch(
        '/boss/deviceSlot/v2/getNbhdConfirmAllDevice',
        {
          deviceGuids: deviceGuids.join(','),
          h5: this.isH5RealTime
        },
        'get'
      )
      load.close()
      return res
    },
    async nbhdDateClick(item, i, it) {
      document.body.addEventListener('click', this.handlePopover, true)
      if (!item.nbhdDailyRes[i].nhbdDeviceInfo || !item.nbhdDailyRes[i].nhbdDeviceInfo.length == 0) {
        let frequencyList = this.$store.state.bmap.chooseTimeSlot.data
        if (frequencyList.length == 0) frequencyList = await this.getAllFrequencyList()
        let res = await this.getDeviceDtls(item.nbhdDailyRes.filter((el) => el.targetDate == it.targetDate)[0].deviceGuids)
        if (res && res.code == this.successCode) {
          if (res.data) {
            this.$set(item.nbhdDailyRes[i], 'nhbdDeviceInfo', res.data || [])
          } else {
            this.$set(item.nbhdDailyRes[i], 'nhbdDeviceInfo', [])
          }
        }
      }
    },
    async changeLimitChoose() {
      this.chooseLimitList = this.$refs.limitFixCp.choose
      this.$refs.limitFix.hide()
      // 如果全选或者全不选
      if (this.cmLimitList.length > 0) {
        if (this.chooseLimitList.length == this.cmLimitList.length) this.ggjcSwitch = true
        else if (this.chooseLimitList.length == 0) this.ggjcSwitch = false
      }
      this.communityList = this.noLimitList.concat(this.getTnTwChooseList())
      this.handleAllCmListLimit(this.chooseLimitList)
    },
    // 根据选择小区变化，重新计算金额
    async getPayPrice() {
      let allChooseList = this.noLimitList.concat(this.getTnTwChooseList())
      let allPrice = allChooseList.reduce((a, b) => a + (b.slotAmount ? b.slotAmount - 0 : 0), 0).toFixed(2)
      if (this.allPrice == allPrice) return
      else this.allPrice = allPrice

      await this.getActives(allChooseList)
      this.payPrice = this.allPrice - this.discountMoney - this.activeShortFee
      this.noCouponPrice = this.payPrice
      if (this.chooseCouponId) {
        if (this.payPrice - this.chooseCoupon > 0) {
          this.payPrice = this.payPrice - this.chooseCoupon
        } else {
          this.$refs.couponPoper.curChooseCpIdx = -1
          this.chooseCouponId = ''
          this.chooseCoupon = 0
        }
      }
    },
    cancelLimitChoose() {
      this.$refs.limitFix.hide()
    },
    searchChange(val) {
      this.nbhdSearchStr = val.replace(/\s*/g, '')
      this.searchNbhd()
    },
    searchNbhd() {
      let trim = this.nbhdSearchStr.trim()
      if (trim == '') {
        this.communityList.forEach((el) => {
          this.$set(el, 'notShow', false)
        })
      } else {
        this.communityList.forEach((el) => {
          if (el.name.indexOf(trim) < 0) this.$set(el, 'notShow', true)
          else this.$set(el, 'notShow', false)
        })
      }
      this.handleShowList(this.allCommunityList.filter((el) => el.type == this.curTab).filter((el) => !el.notShow))
    },
    handleListCtnWidth() {
      if (this.$refs.listCtn) {
        let ww = this.$refs.listCtn.clientWidth - 30
        this.listCtnWidth = ww - (ww % 210)
      }
    },
    handleLimit() {
      // 列表中未返回limitStr字段，从store里的 searchDetail 取对应数据
      const listNbhd = this.$store.state.bmap.searchDetail
      let searchDetailGuids = listNbhd.map((e) => e.guid)
      let limitGuids = listNbhd.filter((t) => (t.limitList && t.limitList.length > 0) || t.remark).map((e) => e.guid)
      // 确认订单请求的列表数据和前一个列表请求的数据不一致，缺少 address limitList remark 字段
      this.communityList.forEach((el) => {
        if (limitGuids.indexOf(el.guid) > -1) {
          const idx = searchDetailGuids.indexOf(el.guid)
          if (idx > -1) {
            el.address = listNbhd[idx].address
            el.limitList = listNbhd[idx].limitList
            el.remark = listNbhd[idx].remark
          }
        }
      })
      this.allCmLimitList = this.communityList.filter((el) => limitGuids.indexOf(el.guid) > -1)
      this.cmLimitList = this.communityList.reduce((res, el) => {
        // 过滤重复的小区
        if (limitGuids.indexOf(el.guid) > -1 && res.every((each) => each.guid != el.guid)) res.push(el)
        return res
      }, [])
      //wyt 20241015去掉老的禁播标签限制小区
      //if (this.cmLimitList.length > 0) this.isShowLimit = true
      this.noLimitList = this.communityList.filter((el) => limitGuids.indexOf(el.guid) == -1)
      this.chooseLimitList = this.cmLimitList
    },
    async getCommunitys() {
      let url = '/boss/deviceSlot/v2/confirmNbhdsDevice'
      if (this.isSmallSn) url = '/boss/deviceSlot/v2/confirmNbhdsDeviceSmallScreen'
      if (this.isWifi) url = '/boss/deviceSlot/v2/confirmNbhdsWifiDevice'
      const res = await this.fetch(url, {
        ...(await this.getOrderOpts()),
        nbGuids: []
      })
      if (res && res.code == this.successCode && res.data) {
        let confirmNbhdRes = res.data.confirmNbhdRes || []
        for (let i = 0; i < confirmNbhdRes.length; i++) {
          confirmNbhdRes[i].type = 0
          confirmNbhdRes[i].isOpen = false
        }
        if (this.isShowBuild) {
          this.allCommunityList = confirmNbhdRes
        } else {
          let twConfirmNbhdRes = res.data.twConfirmNbhdRes || []
          for (let i = 0; i < twConfirmNbhdRes.length; i++) {
            twConfirmNbhdRes[i].type = 1
            twConfirmNbhdRes[i].isOpen = false
          }
          ;[].push.apply(confirmNbhdRes, twConfirmNbhdRes)
          this.allCommunityList = confirmNbhdRes
        }
        if (confirmNbhdRes.length === 0) this.curTab = 1
        else this.curTab = 0
        this.communityList = this.allCommunityList
        // 处理限制列表数据
        this.handleLimit()

        let v = this.communityList
        if (v && v.length > 0 && v.filter((el) => (el.limitList && el.limitList.length > 0) || el.remark).length > 0) {
          this.showLimit()
        }

        // 窗口变化
        this.$nextTick(() => {
          setTimeout(() => {
            this.handleListCtnWidth()
            if (this.hasOwnProperty('listCtnWidth')) {
              window.addEventListener('resize', this.handleListCtnWidth)
            }
          }, 300)
        })
        // 根据列表处理满减 获取活动 价格展示
        if (this.communityList.length > 0) {
          await this.getDiscountList()
          this.getPayPrice()
        }
      }
    },
    fillDays(startDate, endDate) {
      let len = (new Date(endDate) - new Date(startDate)) / (24 * 60 * 60 * 1000) + 1
      let arr = [startDate]
      let i = 1
      while (i < len) {
        let newOne = new Date(new Date(startDate).getTime() + 24 * 60 * 60 * 1000 * i).format().slice(0, 10)
        arr.push(newOne)
        i++
      }
      return arr
    },
    async getActives(list) {
      list = list || this.noLimitList.concat(this.getTnTwChooseList())
      if (list.length == 0) return
      let searchTime = this.$store.state.bmap.mapSearchOptions.time
      let targetDates = this.fillDays(searchTime[0], searchTime[1])
      let nbhdDailyRes = (list || this.communityList).map((el) => el.nbhdDailyRes)
      let timeTotallBoList = targetDates.map((el) => {
        let amount = 0
        nbhdDailyRes.forEach((item) => {
          let data = item.filter((each) => each.targetDate == el)[0]
          if (data) amount += data.slotAmount
        })
        return {
          targetDate: el,
          amount
        }
      })
      let res = await this.fetch('/boss/activity/v2/getTimeActivityList', {
        clienteleGuid: this.customer.customerId,
        timeTotalList: timeTotallBoList,
        totalAmount: this.allPrice,
        h5: this.isH5RealTime
      })
      if (res && res.code == this.successCode) {
        this.activeShortFee = res.data.totalAmount || 0
        this.activeShortName = res.data.name || ''
      }
    },
    toggleCp(data) {
      this.payPrice = this.noCouponPrice - data.data
      this.chooseCoupon = data.data
      this.chooseCouponId = data.id
    },
    getUnseletDevice(data) {
      let deviceList = []
      if (data.allDeviceCount != data.allSelectDeviceCount) {
        this.getConcatDeviceList(data).forEach((build) => {
          build.unitDeviceList.forEach((unit) => {
            unit.deviceList.forEach((device) => {
              if (!device.check) {
                deviceList.push(device.deviceGuid)
              }
            })
          })
        })
      }
      return deviceList
    },
    getNbhdmapAndDaymap(data) {
      let nbhdMap = {}
      let dayMap = {}
      data.forEach((item) => {
        dayMap[item.guid] = item.days
        nbhdMap[item.guid] = this.getUnseletDevice(item)
      })
      return { nbhdMap, dayMap }
    },
    getNoChooseLimitNbhds() {
      // 获取限制小区中未选择的小区
      let chooseLimitNbhdGuids = this.chooseLimitList.map((el) => el.guid)
      return this.cmLimitList.filter((el) => chooseLimitNbhdGuids.indexOf(el.guid) < 0)
    },
    getCommunityOpts() {
      let dayMap = {}
      let nbhdMap = {}
      let isNotfromMap = this.isNotfromMap
      let list = isNotfromMap ? this.options.data : this.options

      // 所有list中去掉限制小区中未勾选的小区
      let noWantNbhdGuids = this.getNoChooseLimitNbhds().map((el) => el.guid)
      list = list.filter((el) => noWantNbhdGuids.indexOf(el.guid) < 0)

      list.forEach((el) => {
        dayMap[el.guid] = el.days
        // 未选择的包括未选择禁选的都要传过去
        if (!el.allDevices || el.allDevices.length == 0) {
          el.allDevices = this.getAllDevice([el])
        }
        nbhdMap[el.guid] = el.allDevices.filter((el) => !el.check).map((el) => el.deviceGuid)
      })
      return { dayMap, nbhdMap }
    },
    getAllDevice(arr) {
      let data = []
      let repeat = (array) => {
        array.forEach((el) => {
          if (!el) return
          let list = this.getItemList(el)
          if (list && list.length > 0) repeat(list)
          else if (el.deviceGuid) data.push(el)
        })
      }
      repeat(arr)
      return data
    },
    getConcatDeviceList(item) {
      return [].concat(item.buildDeviceList || []).concat(item.twBuildDeviceList || [])
    },
    getItemList(item) {
      if (item.hasOwnProperty('buildDeviceList') || item.hasOwnProperty('twBuildDeviceList')) {
        return this.getConcatDeviceList(item)
      } else {
        return item.deviceList || item.unitDeviceList || []
      }
    },
    async getOrderOpts() {
      let communityListOpts
      if (this.isNotfromMap) {
        let list = this.options.data // 所有list中去掉限制小区中未勾选的小区
        let noWantNbhdGuids = this.getNoChooseLimitNbhds().map((el) => el.guid)
        list = list.filter((el) => noWantNbhdGuids.indexOf(el.guid) < 0)
        communityListOpts = this.getNbhdmapAndDaymap(list)
      } else {
        communityListOpts = this.getCommunityOpts()
      }

      let frequencyList = this.$store.state.bmap.chooseTimeSlot.data
      if (frequencyList.length == 0) frequencyList = await this.getAllFrequencyList()

      let addressCode = ''
      if (!this.isNotfromMap) {
        let seniorCityGuid = this.$store.state.bmap.mapSearchOptionsSenior.city
        if (!seniorCityGuid) {
          addressCode = null
        } else {
          addressCode = this.$store.state.bmap.mapCityList.filter((el) => el.guid == seniorCityGuid)[0].dicCode
          // addressCode = null
        }
      } else if (!this.isExport) {
        if (this.filtro) {
          let cdAdds = this.filtro.addressCodes || []
          addressCode = cdAdds.map((el) => {
            let elStr = el + ''
            if (elStr.endsWith('.')) el = elStr.substring(0, elStr.length - 1)
            return el
          })
          if (cdAdds.length === 0) {
            // 全国
            addressCode = (this.$store.state.common.originUserDistTree || []).map((el) => el.code)
          }
        }
      }

      let form = this.$store.state.bmap.mapSearchOptions
      let startDate = form.time[0] ? (form.time[0] + '').trim().slice(0, 10) : ''
      let endDate = form.time[1] ? (form.time[1] + '').trim().slice(0, 10) : ''
      if (!endDate) {
        let needDays = this.options.needDays ? this.options.needDays - 1 : 0
        let date = new Date(new Date(form.time[0]).getTime() + needDays * 24 * 60 * 60 * 1000)
        endDate = date.getFullYear() + '-' + this.fillZero(date.getMonth() + 1) + '-' + this.fillZero(date.getDate())
      }

      const { targetFlowOrbudgetAmount, clienteleName, packageInfoCodes, customerId, userId, industryCodes, contractNo, displayRegion, noPlayingLabels } = this.filtro
      const display = this.isNotfromMap ? displayRegion : form.displayRegion
      const newNoPlayingLabels = this.isNotfromMap ? noPlayingLabels : form.noPlayingLabels
      return {
        ...this.filtro,
        ...this.getLabelsParam(), // 搜索便签相关传参
        addressCodes: this.isNotfromMap ? addressCode || [] : addressCode?[addressCode]:[],
        ...communityListOpts,
        frequencyList: !this.isWifi ? frequencyList : undefined,
        contentTime: !this.isWifi ? form.contentTime : undefined,
        orderCode: this.isWifi ? form.orderCode || '' : undefined,
        startDate,
        endDate,
        couponGuid: this.chooseCouponId,
        targetFlowOrbudgetAmount: targetFlowOrbudgetAmount || '',
        h5: this.isH5RealTime,
        clienteleName: clienteleName || '',
        packageInfoCodes: packageInfoCodes || [],
        customerId: customerId || '',
        userId: userId || '',
        industryCodes: industryCodes || [],
        contractNo: contractNo || '',
        displayRegion: display,
        noPlayingLabels: newNoPlayingLabels
      }
    },
    getLabelsParam() {
      // 搜索便签相关传参 社区类型 社区收入  用户画像  收费方式等
      let codeMap = this.$store.state.label.codeMap
      let { labels, persons } = this.$store.state.label.confirm
      let nbhdLabels = labels.filter((el) => codeMap[el].kind == 'NBHD')
      let orderLabels = labels.filter((el) => codeMap[el].kind == 'ORDER')
      return { nbhdLabels, orderLabels, personsLabels: persons }
    },
    fillZero(v) {
      let trimV = (v + '').trim()
      return trimV.length == 1 ? '0' + trimV : trimV
    },

    showLimit() {
      //wyt 20241015 去掉老的禁播标签保留小区设置
      // if (!this.hasShowLimit) {
      //   this.$refs.limit.show()
      //   this.hasShowLimit = true
      // }
      this.chooseLimitList = this.cmLimitList;
      this.ggjcSwitch = true
    },
    setOrder() {
      if (this.isSubmiting) return

      if (this.noLimitList.concat(this.getTnTwChooseList()).length === 0) {
        return this.messageTip('未选择小区', 2)
      }

      // if (this.chainFlag == -1) return this.messageTip('请勾选上链服务再提交订单～', 2)

      // 自选时段搜索总量非300次二次确认
      let chooseTimeSlot = this.$store.state.bmap.chooseTimeSlot
      if (chooseTimeSlot.idx - 0 === 1 && chooseTimeSlot.data.reduce((data, cur) => data + (cur.playCount - 0), 0) - 0 !== 300) {
        this.$confirm('本订单所选的单日播放次数非“300次/天”，请确认是否继续提交？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.saveOrder()
          })
          .catch(() => {})
      } else {
        this.saveOrder()
      }
    },
    // 保存订单组别
    async saveOrderGroup(orderGroups) {
      const result = await this.fetch('/orderlite/contract/api/v4/contract/order-groups', { orderGroups }, 'post')
      if (result.code === 0) {
        return result.data
      }
    },
    // confirm消息弹窗
     confirmMessage(oldDate, newDate) {
      return new Promise((resolve, reject) => {
         this.$confirm(`<div><div>是否确认更新当前组别</div><div>原时间范围${oldDate.startDate}~${oldDate.endDate}调整为${newDate._startDate}~${newDate._endDate}</div></div>`, '温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              type: 'warning'
         }).then(res => {
          resolve(true)
         }).catch(err => {
          resolve(false)
        })
      })
    },
    async saveOrder() {
      this.isSubmiting = true
      let currentGroupCode = ''
      if (!this.hasGroupListFlag) {
        // 没有订单组别
        const orderGroups = this.orderGroupList.map(s => {
          return {
            startDate: s.startDate,
            endDate: s.endDate,
            contractCode:s.contractCode
          }

        })
        const saveResult = await this.saveOrderGroup(orderGroups)
        console.log(saveResult)
        currentGroupCode = saveResult[0].code

      } else {
        const timeStr = `${this.formatterTiemStr(this.searchInfo('time0'))} ~ ${this.formatterTiemStr(this.searchInfo('time1') )}`
        let startDate = timeStr.split('~')[0].trim()
        let endDate = timeStr.split('~')[1].trim()
        const flag = this.compareTime({ startDate, endDate }, this.orderGroupCode)
        if (!flag) {
          let _startDate = +new Date(this.orderGroupCode.startDate) > +new Date(startDate) ? startDate : this.orderGroupCode.startDate
          let _endDate = +new Date(this.orderGroupCode.endDate) < +new Date(endDate) ? endDate : this.orderGroupCode.endDate
          // const confirm = await this.$confirm(`<div><div>是否确认更新当前组别</div><div>原时间范围${this.orderGroupCode.startDate}~${this.orderGroupCode.endDate}调整为${_startDate}~${_endDate}</div></div>`, '温馨提示', {
          //   confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          //   dangerouslyUseHTMLString: true,
          //   type: 'warning'
          // })
          const confirm = await this.confirmMessage(this.orderGroupCode,{_startDate,_endDate})
          if (confirm) {

            const index = this.orderGroupList.findIndex(s => s.code === this.currentGroup.code)
            this.orderGroupList[index] = {
              ...this.currentGroup,
              startDate: _startDate,
              endDate: _endDate

            }
            await this.saveOrderGroup(this.orderGroupList)
            currentGroupCode = this.currentGroup.code
          } else {
            this.isSubmiting = false
            return false
          }
        } else {
          currentGroupCode = this.currentGroup.code
        }
      }
      let submitApi = '/dsp/web/order/v2/saveOrderDevice'
      if (this.isSmallSn) submitApi = '/dsp/web/order/v2/saveOrderDeviceSmallScreen'
      if (this.isWifi) submitApi = '/dsp/web/order/v2/saveOrderDeviceWiFiScreen'
      let opt = await this.getOrderOpts()
      if (opt.targetFlowOrbudgetAmount) opt.targetFlowOrbudgetAmount = opt.targetFlowOrbudgetAmount * 1000 // 流量须乘以1000传过去
      if (opt.dailyFlowLimit) opt.daliFlowLimit = opt.dailyFlowLimit * 1000
      if (opt.unitPrice) opt.unitPrice = opt.unitPrice * 1000 // 须乘以1000传过去

      // CPR+ 订单目标流量定制相关传参
      if (this.targetLabels.length) opt.orderTargetLabels = this.targetLabels
      // saveOrder接口的noPlayingLabels要求string类型，所以需要把数组通过中文逗号拼接成字符串 wyt 20241018
      if (opt.noPlayingLabels){
        opt.noPlayingLabels = opt.noPlayingLabels.join("，")
      }
      opt.orderGroupCode = currentGroupCode
      const res = await this.fetch(submitApi, {
        ...opt,
        freeMark: this.payWay == 1 ? true : false,
        predictFlow: (this.cpmAccountNum || 0) * 1000,
        chainFlag: this.chainFlag,
        pictureStorageDays: this.storeDays
      })
      if (res && res.code == this.successCode) {
        if (res.data && res.data.guid) {
          let snNum = this.chooseNum(2)
          let from = this.isNotfromMap ? 'smart' : 'map'
          let freeMark = this.payWay
          this.goUrl('/orderPay', {
            id: res.data.guid,
            snNum,
            from,
            freeMark,
            isPkg: this.options.searchChargeWay === 'pkg' ? 1 : ''
          })
          // 更改为刷新跳转，防止点位搜索页面keepAlive再次点击点位搜索时仍保留之前的页面状态
          // location.href = `/orderPay?id=${res.data.guid}&snNum=${snNum}&from=${from}&freeMark=${freeMark}`
        } else this.messageTip(res.message || '请求失败，请稍后重试')
      } else if (res.code === 900501) {
        this.messageTip((res && res.message) || '请求失败，请稍后重试')
      }
      this.isSubmiting = false

      tzx_czcPush('makeOrder')
      tzx_czcPush('orderUseCp', this.curChooseCpIdx == -1 ? 0 : 1)
    },
    async getShortAll() {
      let list = this.isNotfromMap ? this.options.data : this.options
      let res = await this.fetch('/boss/deviceSlot/v2/getNbhdShortageAllDeviceMap', {
        ...(await this.getOrderOpts()),
        nbGuids: list.map((el) => el.guid)
      })
      if (res && res.code == this.successCode && res.data) {
        let list = (res.data.lackNbhdList || []).concat(res.data.twLackNbhdList || [])
        list.forEach((el) => {
          this.$set(el, 'isOpen', false)
          return el
        })
        this.communityListShort = [res.data.lackNbhdList || [], res.data.twLackNbhdList || []]
      }
    },
    async getTimeRanges() {
      let timesAll = this.$store.state.order.timeRanges
      if (!timesAll) {
        await this.$store.dispatch('order/getTimeRanges')
        timesAll = this.$store.state.order.timeRanges
      }
      return timesAll
    },
    async getAllFrequencyList() {
      let bmapStore = this.$store.state.bmap
      let allTimeRanges = bmapStore.allTimeRanges
      if (allTimeRanges.length == 0) {
        await this.$store.dispatch('getTimeRanges')
        allTimeRanges = bmapStore.allTimeRanges
      }
      let ids = allTimeRanges.map((el) => el.guid)
      let frequencyList = this.isFormSearch ? bmapStore.chooseTimeSlot.data : bmapStore.recommendTimeSlotData
      return frequencyList.map((el) => {
        let idx = ids.indexOf(el.frequencyTime)
        if (idx > -1) el.frequencyName = allTimeRanges[idx].frequencyName
        else el.frequencyName = '未知'
        return el
      })
    },
    async getTimeSlots() {
      let arr = this.$store.state.bmap.chooseTimeSlot.data
      if (arr.length == 0) arr = await this.getAllFrequencyList()
      return arr.map((el) => el.frequencyName + `<span style="color: #999;margin-left: 5px;margin-right: 10px;">(播放${el.playCount}次)</span>`)
    },
    async shortageExport() {
      let { orderLabels } = this.getLabelsParam()
      const { contentTime, startDate, endDate, nbhdMap, frequencyList } = await this.getOrderOpts()
      await this.$export('/boss/deviceSlot/v2/exportShortagePoints', {
        orderLabels,
        contentTime,
        startDate,
        endDate,
        nbhdMap,
        timeSegments: frequencyList
      })
    },
    handleCustomize(labels) {
      this.targetLabels = labels
    }
  }
}
</script>

<style lang="sass">
  .body_order_confirm
    ::v-deep .el-popover
      z-index: 2007 !important

  .put_import_container
    .order_confirm_ctn
      min-width: 1000px
      padding: 0 20px

  .userpfs_pop
    border: 1px solid #282729
    .userpfs
      line-height: 1
      margin-bottom: 10px
      color: #282729

    .popper__arrow
      border-top-color: #282729 !important

  .usepf_span.confirm
    width: 100%

    span
      margin-right: 0 !important
      padding-right: 0 !important

    > span
      line-height: 1
      display: inline-block
      width: calc(100% - 100px)
      position: relative
      border-right: none !important
      top: 2px

  .city_pop_box
    height: 300px
    overflow: hidden auto
</style>

<style lang="sass" scoped>
  .itemTag
    float: right
    position: relative
    .selectText
      width:330px
      position: absolute
      left: 90px
      top: 6px
      height: 22px
      line-height: 22px
      background: white
      z-index: 999
      cursor: pointer
      display: flex
      align-items: center
      span
        border-right: none !important
        margin-right: 10px !important
        padding-right: 10px !important
    i
      height: 24px
      margin-left: 10px
      font-size: 24px
      cursor: pointer
      color: #599bf4
      vertical-align: middle
    &::before
      content : '*'
      color: red
      padding-right: 2px

  .detail_de
    width: 200px
    height: 40px
    color: #666666
    background: #F5F5F5
    border-radius: 2px
    padding: 10px
    float: left
    margin: 5px
    cursor: default
    &.active
      border: 1px solid #6296FF
      background: #fff
    i
      margin-left: 10px
    span
      color: #282729
      font-weight: 500
      font-size: 14px

  .vip_tip
    width: 300px
    font-size: 16px
    margin: 50px auto
    text-align: center

  .order_confirm_ctn
    height: 100%
    position: relative

    .gg-tabs
      border: 1px solid #E9E9E9
      height: 30px
      line-height: 28px

      .gg-tab
        border: none
        border-right: 1px solid #E9E9E9
        margin-right: 0
        border-radius: 0
        height: 28px
        line-height: 28px

      ::v-deep .el-button
        border: none
        border-left: 1px solid #E9E9E9
        background: #F5F5F5
        height: 28px
        position: relative
        top: -1px

  .limit-fix
    ::v-deep .fix-center-main
      background: #fff

  .each-date
    display: inline-block
    width: 170px
    height: 40px
    line-height: 40px
    text-align: center
    background: #F5F5F5
    margin: 5px

  .order-confirm
    padding: 20px 0
    height: calc(100% - 60px)
    overflow: auto
    position: relative
    background: #fff

    &.limit
      height: calc(100% - 100px)

    .part-round
      height: 40px
      background-color: #F5F5F5
      padding: 10px 0 0 20px

      .part_round_img
        height: 16px
        position: relative
        top: 3px

      .searchArea
        width: 240px
        margin-top: -5px
        // margin-right: 20px
        ::v-deep .el-input__inner
          height: 30px
          border-radius: 4px
          font-size: 12px

        ::v-deep .el-input__icon
          line-height: 30px

        ::v-deep input
          padding-right: 50px

        ::v-deep .el-input__suffix
          right: 25px

      span
        margin-left: 8px
        font-size: 14px
        font-weight: 500

    .cf-top
      margin-bottom: 20px
      line-height: 1

      .part-title
        font-weight: 600

        .fr
          color: #FF3973
          width: 100px
          height: 30px
          line-height: 30px
          border: 1px solid #FF3973
          border-radius: 4px
          font-size: 14px
          text-align: center
          cursor: pointer

      .user-info
        height: 60px
        padding: 20px
        border: 1px solid #e9e9e9
        border-top: none

        .each
          color: #999
          line-height: 1
          padding-right: 20px
          margin-right: 20px
          border-right: 1px solid #e9e9e9

          &.noMr
            border-right: none

          span
            color: #282729
            font-weight: 400

    .cf-info
      margin-bottom: 20px

      .put-out
        border: 1px solid #E9E9E9
        border-top: 0
        padding: 10px

      .less
        color: #999
        padding-left: 20px
        border-left: 1px solid #e9e9e9
        line-height: 1
        margin-top: 6px

        span
          color: #282729

          &.btn
            color: #6296FF
            cursor: pointer
            margin-left: 8px

      .put-time
        padding: 10px 20px
        line-height: 26px
        font-weight: 400
        margin-bottom: 10px
        border-radius: 4px
        border: 1px solid #E9E9E9
        color: #999
        &.cpr_label
          display: flex
          align-items: center
          justify-content: flex-start
        .cprplus_mode
          display: flex
          align-items: center
          justify-content: flex-start
          flex-basis: 102px
          flex-shrink: 0

        .no-br
          border-right: none

          span
            border-right: none

        > span
          display: inline-block
          span
            font-weight: 500
            padding-right: 20px
            margin-right: 20px
            border-right: 1px solid #e9e9e9
            color: #282729
            &.date
              font-weight: 600
          .el-popover__reference
            color: #999

        .row_els
          margin-right: 0
          width: 100%
          display: inline-block
          vertical-align: top
          text-overflow: ellipsis
          overflow: hidden
          white-space: nowrap

          span
            color: #282729

        .value_els
          max-width: 300px
          text-overflow: ellipsis
          overflow: hidden
          white-space: nowrap
          display: inline-block
          line-height: 1
          border-right: none
          padding-right: 0
          margin-right: 0
          position: relative
          top: 2px

        .pkg_list
          display: inline-block
          width: calc(100% - 80px)
          margin-right: 0
          padding-right: 0
          line-height: 26px
          vertical-align: top

      .put-time:last-child
        margin-bottom: 0

      .pkg_list_ctn
        .btn
          padding-left: 20px
          border-left: 1px solid #e9e9e9
          line-height: 1
          margin-top: 8px
          cursor: pointer

    .put_info
      .put-out
        border: 1px solid #E9E9E9
        border-top: 0
        padding: 10px
      .itemFlex
        display: flex
        justify-content: space-around
      .put-time
        padding: 20px
        line-height: 26px
        font-weight: 400
        margin-bottom: 10px
        border-radius: 4px
        border: 1px solid #E9E9E9
        color: #999
        .put_title
          font-size: 16px
          font-weight: 400
          color: rgba(40, 39, 41, 1)
          line-height: 22px

        .fr
          .frTitle
            padding-right: 20px
            margin-right: 20px
            border-right: 1px solid #e9e9e9

          span
            display: inline-block
            font-weight: 400
            color: #999999

            &.data
              color: #282729
              font-weight: 600

    .detail_screen
      margin-top: 20px
      display: inline-block

    .community-list
      border: 1px solid #e9e9e9
      border-top: none
      padding: 10px 10px 0
      // margin-top: -10px
      .none
        text-align: center
        line-height: 50px
        color: #999

      .community-item
        padding: 20px
        border-radius: 4px
        border: 1px solid #e9e9e9
        margin-bottom: 10px
        cursor: pointer
        min-height: 61px

        &.isOpen
          padding: 20px 20px 0

          .top
            i
              transform: rotate(180deg)

        .top
          &.open
            padding-bottom: 10px
            border-bottom: 1px solid #eee
            margin-bottom: 5px

          .fr
            color: #999

            span
              padding-right: 20px
              margin-right: 20px
              border-right: 1px solid #e9e9e9

              &.price
                color: #FF3973

              &.num
                color: #282729

              &.no-br
                padding-right: 0
                margin-right: 0
                border-right: none

                span
                  border-right: none

          i
            margin-left: 20px

        .table
          line-height: 40px
          width: calc(50% - 10px)
          background: #F5F5F5
          float: left
          margin-top: 10px
          margin-bottom: -1px
          position: relative

          &:nth-of-type(2n)
            float: right

          &.small
            width: calc(25% - 15px)
            margin-right: 20px
            text-align: center

            &:nth-of-type(2n)
              float: left

            &:nth-of-type(4n)
              margin-right: 0

          > div
            border-bottom: 1px solid #e9e9e9

          .line-bottom
            height: 2px
            width: 100%
            border-bottom: none
            background: #F5F5F5
            position: absolute
            bottom: 0
            left: 0

          .date
            padding: 0 12px

            .fr
              color: #999
              font-size: 12px

              span
                font-size: 14px
                color: #FF3973

          .item
            width: 50%
            float: left
            color: #999
            text-align: center
            font-size: 12px
            position: relative

            .item-line
              position: absolute
              right: 0
              top: 10px
              width: 1px
              height: 20px
              background: #E9E9E9

            span
              color: #282729

              &.num
                color: #FF3973
                margin-left: 5px

    .cf-btm
      background: #F5F5F5
      padding: 0 20px

      .coupon
        &.open
          .cp-main
            height: auto

          .cp-top
            .cp-tabs
              display: block

          i.el-icon-arrow-down
            transform: rotate(180deg)

        .cp-top
          line-height: 56px
          position: relative

          .cp-tabs
            display: none
            position: absolute
            left: 0
            top: 15px
            text-align: center

            .cp-tab
              display: inline-block
              width: 100px
              height: 30px
              line-height: 30px
              background: #fff
              border: 1px solid #e9e9e9
              border-radius: 4px
              margin-right: 20px
              cursor: pointer

              &.cur
                border: none
                background: linear-gradient(315deg, rgba(250, 234, 97, 1) 0%, rgba(255, 184, 31, 1) 100%)
                border-radius: 4px 4px 0px 0px

          .fr
            cursor: pointer
            font-size: 18px
            font-weight: 600

            i
              font-size: 14px
              margin-right: 10px

            span
              display: inline-block
              position: relative
              top: -2px
              margin-left: 10px
              width: 64px
              height: 24px
              line-height: 24px
              text-align: center
              color: #fff
              font-size: 12px
              background: #FF3973
              border-radius: 4px

        .cp-main
          background: #fff
          height: 0
          transition: all .4s
          max-height: 360px
          overflow: auto
          position: relative

          .cp-ctn
            padding: 20px
            overflow: auto

          .cp-item
            width: calc(50% - 10px)
            height: 100px
            float: left
            border: 1px solid #e9e9e9
            border-radius: 7px
            margin-bottom: 10px
            padding: 20px 0
            cursor: pointer
            position: relative
            overflow: hidden

            &:nth-of-type(2n)
              float: right

            &.choose
              border: 2px solid #FF3973

              .cp-dtl
                width: calc(100% - 140px)

              .icon-buzhoutiao1
                display: block

            &.disable
              cursor: not-allowed

              .cp-dtl
                line-height: 20px

              .fee, .cp-dtl
                color: #999

            .icon-buzhoutiao1
              position: absolute
              right: 10px
              font-size: 18px
              margin-top: 20px
              color: #FF3973
              display: none

            .will-end
              width: 80px
              position: absolute
              right: 0
              top: 0

            .fee
              float: left
              width: 120px
              line-height: 60px
              border-right: 1px solid #e9e9e9
              text-align: center
              font-size: 28px
              font-weight: bold
              color: #FF3973

              &.has-type
                line-height: 40px

              span
                font-size: 20px

              i
                font-size: 12px
                color: #999
                display: block
                line-height: 1
                font-style: normal

            .cp-dtl
              display: inline-block
              width: calc(100% - 120px)
              padding: 0 20px
              line-height: 30px
              font-size: 16px
              font-weight: 600
              float: left

              .time
                font-size: 14px
                font-weight: 400
                color: #999

              .reason
                font-weight: 600
                color: #282729
                font-size: 14px

      .final
        font-weight: 600
        margin-top: 20px
        border-top: 1px solid #e9e9e9
        border-bottom: 1px solid #e9e9e9
        padding: 10px 0
        line-height: 30px
        text-align: right

        div
          font-weight: 400
          color: #999

          span
            color: #999
            margin-left: 5px

            &.price
              color: #282729

            &.cp
              color: #FF3973

  .footer, .upFooter
    z-index: 9
    position: absolute
    left: 0
    width: 100%
    border-top: 1px solid #E9E9E9
    padding: 10px 20px
    background: #fff

  .upFooter
    height: 40px
    bottom: 60px
    > .fl
      margin-top: -2px
      ::v-deep .canUse
        width: 75px
        height: 24px
        background: #FF3973
        border-radius: 4px
        text-align: center
        // margin: 8px 0 0 10px
        line-height: 27px
        color: #FFFFFF
        cursor: pointer

        ::v-deep .el-popper
          padding: 0 !important

    i
      margin-right: 5px
      cursor: pointer

    span
      cursor: pointer
      margin: 15px 12px 0 5px
      color: #FF3973

    ::v-deep .el-switch
      margin-top: -5px

  .footer
    height: 60px
    bottom: 0
    display: flex
    justify-content: space-between
    align-items: center
    overflow: auto hidden
    .fx_l
      display: flex
      align-items: center
      justify-content: flex-start
      min-width: 750px
    .ft_choose
      display: flex
      align-items: center
      justify-content: flex-start
      flex-shrink: 0
      height: 60px
      border-left: 1px solid #d4d4d4
      padding: 0 20px
      ::v-deep .el-radio
        margin-right: 15px
        &:last-child
          margin-right: 0
        .el-radio__input
          float: right
          margin-left: 5px
          &.is-checked
            .el-radio__inner
              border-color: #FF3973
              background: #FF3973
        .el-radio__label
          font-size: 12px
          color: #282729
          span
            color: #999
      ::v-deep .el-input-number.is-controls-right
         .el-input__inner
          padding-left: 0
          padding-right: 30px
    .sunCount
      cursor: pointer
      display: flex
      justify-content: flex-start
      align-items: center
      margin-right: 20px
      .s_title
        flex-shrink: 0
        font-size: 14px
        font-weight: 400
        color: #282729
      .numDe
        .numUp
          font-size: 18px
          font-weight: 600
          color: #FF3973
          line-height: 24px
        .numDown
          text-decoration: line-through
          font-size: 12px
          margin-left: 2px
        .icon-bangzhu
          color: #FF7413
          position: relative
          left: 4px

  .tableBox
    width: 600px
    max-height: 370px
    overflow: hidden
    font-size: 12px
    color: #666666
    border-top: 1px solid #F5F5F5
    border-left: 1px solid #F5F5F5

    tr
      td
        border-right: 1px solid #F5F5F5
        border-bottom: 1px solid #F5F5F5

        ul
          li
            height: 30px
            line-height: 30px
            border-bottom: 1px solid #F5F5F5

          li:last-child
            border-bottom: 0

      td:first-child
        width: 100px
        text-align: center

      td:nth-child(2)
        width: 100px
        text-align: center

      td:last-child
        width: 380px
        padding-left: 20px
        color: #282729

  .countDetail
    width: 200px
    color: #282729

    .countLine
      margin: 10px 5px

      span
        font-size: 14px

      span:last-child
        color: #FF3973

  ::v-deep .fix-center-main
    background-color: #F5F5F5

  .watchSev_title
    font-size: 14px
    font-weight: 400
    color: #282729
    line-height: 20px
    display: table
    margin: 0 auto
    margin-bottom: 10px

  .watchSev_content
    font-size: 12px
    font-weight: 400
    color: #999999

  .exp_btn
    background: linear-gradient(315deg, #ff846d 0%, #ff3973 100%)
    border: none
    border-radius: 4px
    color: #fff
    cursor: pointer
    margin: 15px 10px 0 0
    text-align: center
    width: 100px
</style>
